export default class Utilities {
    static isLogged = function() {
        // console.log('Checkeando si esta logueado');

        try{
            if(sessionStorage.getItem("user")){
                if(sessionStorage.getItem("user_hash") == this.generateHash(sessionStorage.getItem("user_id"))){
                    return true
                }
                else{
                    sessionStorage.clear()
                    return false
                }
            }

            return false
        }
        catch(e){
            console.log(e)

            return false
        }
    }

    static generateHash = function(s){
        let texto = String(s)
        return texto.split("").reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a},0);
    }

}
